/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Assign_Track_NoneInputs */



/**
* | output |
* | --- |
* | "Clear the track assignment of the selected event(s)" |
*
* @param {Shortcut_Keys_Desc_Assign_Track_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_assign_track_none = /** @type {((inputs?: Shortcut_Keys_Desc_Assign_Track_NoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Assign_Track_NoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer l'affectation de piste de l'événement sélectionné")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Streckenzuordnung der ausgewählten Veranstaltung(en) löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella l'assegnazione del percorso per l'evento/gli eventi selezionato/i")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сбросить назначение трека для выбранного(ых) события(й)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar la asignación de pista del/los evento(s) seleccionado(s).")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清除所选赛事的赛道分配")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントのトラック割り当てを解除します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट(ओं) के ट्रैक असाइनमेंट को साफ़ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Limpar a atribuição de pista do(s) evento(s) selecionado(s)")
	return /** @type {LocalizedString} */ ("Clear the track assignment of the selected event(s)")
});